import {useEffect} from "react";
import {useModalStore} from "@/Stores/Site/ModalStore";
import {useModalStore as useModalStoreProfile} from "@/Stores/Site/Profile";
import {useModalStore as useModalStoreProduct, useQuickViewStore} from "@/Stores/Site/Product";
import {useNotificationStore} from "@/Stores/NotificationStore";
import {useBuyOneClickStore} from "@/Stores/Site/BuyOneClickStore";
import {selectorCloseProfileDrawer} from "@/Stores/Site/Profile/Selectors";
import {useSelectSizeStore} from "@/Stores/Site/Product/SelectSizeStore";

export default function useCloseModalWindows(props) {
    const {stores = {}} = props;
    const {modalStore = {}, subMenuStore = {}} = stores;

    const closeProfileDrawer = useModalStoreProfile(selectorCloseProfileDrawer);
    const closeSearchModal = useModalStore(state => state.closeSearchModal);
    const closeWhySuchPriceModal = useModalStore(state => state.closeWhySuchPriceModal);
    const closeModalPriceInfo = useModalStoreProduct(state => state.closeModalPriceInfo);
    const closeModalFindOutPrice = useModalStoreProduct(state => state.closeModalFindOutPrice);
    const closeModalAuthOrRegister = useModalStore(state => state.closeModalAuthOrRegister);
    const closeModalNotification = useNotificationStore(state => state.close);
    const closeModalBuyOneClick = useBuyOneClickStore(state => state.closeModal);
    const closeModalSelectSize = useSelectSizeStore(state => state.closeModalSelectSize);
    const closeModalQuickView = useQuickViewStore(state => state.closeModal);

    useEffect(() => {
        setTimeout(() => {
            modalStore.closeDiamondHeadsetStarsModal();
            modalStore.closeModalAdditionalChoiceSoul();
            modalStore.closeModalScanner();
            subMenuStore.closeSubMenu();
            stores.mobileMenuStore.closeMobileMenu();
            subMenuStore.open = false;
            subMenuStore.closeMobileSubMenu();
            // Zustand
            closeModalAuthOrRegister() // Модальное окно "Авторизация или Регистрация"
            closeProfileDrawer(); // Модальное окно "Профиль пользователя"
            closeSearchModal(); // Модальное окно "Поиск"
            closeWhySuchPriceModal(); // Модальное окно "Почему такая цена" (деталка товара)
            closeModalPriceInfo(); // Модальное окно "информация о цене"
            closeModalFindOutPrice(); // Модальное окно "узнать цену"
            closeModalNotification(); // Модальное окно "Уведомления"
            closeModalBuyOneClick(); // Модальное окно "Купить в один клик"
            closeModalSelectSize(); // Модальное окно "Выбор размера при добавлении в корзину"
            closeModalQuickView(); // Модальное окно "Быстрый просмотр"
        }, 10);
    }, []);
}
